var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHomeVersionDefault)?_c('ul',{staticClass:"type-toggle nav nav-fill nav-pills",attrs:{"id":"pills-tab","role":"tablist"}},[_c('v-sheet',{staticClass:"mx-auto slider-width",staticStyle:{"background":"none"},attrs:{"max-width":"100%","width":"100%"}},[_c('v-slide-group',{staticClass:"menu-center align-items-center",attrs:{"show-arrows":"mobile","mandatory":""}},[_vm._l((_vm.sortedMenuList),function(menu,index){return [(
            menu !== undefined &&
              menu.type === 'principal' &&
              menu.id === _vm.productTypeIds.food &&
              !_vm.disableAddFood &&
              _vm.displayComidas() &&
              _vm.validFood
          )?_c('v-slide-item',{key:("food" + index),staticClass:"px-2",scopedSlots:_vm._u([{key:"default",fn:function(ref){
          var active = ref.active;
return [_c('v-btn',{staticClass:"mb-2 slider-btn",class:'active',attrs:{"input-value":active,"depressed":"","rounded":"","ripple":false,"color":_vm.colorsFoodPrimary},on:{"click":function($event){_vm.onTab(_vm.productTypeIds.food);
              _vm.selectColor({
                primaryColor: _vm.colorsFoodPrimary,
                secondaryColor: _vm.colorsFoodSecondary
              });}}},[_vm._v("\n            "+_vm._s(_vm.$t("common.food"))+"\n          ")])]}}],null,true)}):_vm._e(),(
            menu !== undefined &&
              menu.type === 'principal' &&
              menu.id === _vm.productTypeIds.drinks &&
              !_vm.disableAddDrinks &&
              _vm.displayBebidas() &&
              _vm.validDrinks
          )?_c('v-slide-item',{key:("drinks" + index),staticClass:"px-2",scopedSlots:_vm._u([{key:"default",fn:function(ref){
          var active = ref.active;
          var toggle = ref.toggle;
return [_c('v-btn',{staticClass:"mb-2 slider-btn",class:'active',attrs:{"depressed":"","rounded":"","input-value":active,"ripple":false,"color":_vm.colorsDrinksPrimary},on:{"click":function($event){_vm.onTab(_vm.productTypeIds.drinks);
              toggle;
              _vm.selectColor({
                primaryColor: _vm.colorsDrinksPrimary,
                secondaryColor: _vm.colorsDrinksSecondary
              });}}},[_vm._v("\n            "+_vm._s(_vm.$t("common.drinks"))+"\n          ")])]}}],null,true)}):_vm._e(),(
            menu !== undefined &&
              menu.type === 'principal' &&
              menu.id === _vm.productTypeIds.dessert &&
              !_vm.disableAddDessert &&
              _vm.displayPostres() &&
              _vm.validDessert
          )?_c('v-slide-item',{key:("dessert" + index),staticClass:"px-2",scopedSlots:_vm._u([{key:"default",fn:function(ref){
          var active = ref.active;
          var toggle = ref.toggle;
return [_c('v-btn',{staticClass:"mb-2 slider-btn",class:'active',attrs:{"depressed":"","rounded":"","input-value":active,"ripple":false,"color":_vm.colorsDessertPrimary},on:{"click":function($event){_vm.onTab(_vm.productTypeIds.dessert);
              toggle;
              _vm.selectColor({
                primaryColor: _vm.colorsDessertPrimary,
                secondaryColor: _vm.colorsDessertSecondary
              });}}},[_vm._v("\n            "+_vm._s(_vm.$t("common.dessert"))+"\n          ")])]}}],null,true)}):_vm._e(),(
            menu !== undefined &&
              menu.type === 'menus' &&
              _vm.displayMenu(menu) &&
              !_vm.disableMenuBySchedule(menu) &&
              _vm.validMenuProducts(menu)
          )?_c('v-slide-item',{key:index,staticClass:"px-2",scopedSlots:_vm._u([{key:"default",fn:function(ref){
          var active = ref.active;
          var toggle = ref.toggle;
return [_c('v-btn',{key:("menu_" + index),staticClass:"mb-2 slider-btn",attrs:{"input-value":active,"ripple":false,"color":menu.primaryColor ? menu.primaryColor : '#000000',"depressed":"","rounded":""},on:{"click":function($event){_vm.onTab(menu.id);
              toggle;
              _vm.selectColor(menu);}}},[_vm._v("\n            "+_vm._s(_vm.translate("name", menu))+"\n          ")])]}}],null,true)}):_vm._e(),(
            menu !== undefined &&
              menu.type === 'menu_group' &&
              _vm.displayMenu(menu) &&
              !_vm.disableMenuGroup(menu) &&
              _vm.validMenuGroupProducts(menu)
          )?_c('v-slide-item',{directives:[{name:"touch",rawName:"v-touch",value:({
            left: function () { return _vm.$emit('childSwipe', { direction: 'Left', index: 0 }); },
            right: function () { return _vm.$emit('childSwipe', { direction: 'Right', index: 0 }); },
            up: function () { return _vm.$emit('childSwipe', { direction: 'Up', index: 0 }); },
            down: function () { return _vm.$emit('childSwipe', { direction: 'Down', index: 0 }); }
          }),expression:"{\n            left: () => $emit('childSwipe', { direction: 'Left', index: 0 }),\n            right: () =>\n              $emit('childSwipe', { direction: 'Right', index: 0 }),\n            up: () => $emit('childSwipe', { direction: 'Up', index: 0 }),\n            down: () => $emit('childSwipe', { direction: 'Down', index: 0 })\n          }"}],key:("menu_group" + index),staticClass:"px-2",scopedSlots:_vm._u([{key:"default",fn:function(ref){
          var active = ref.active;
          var toggle = ref.toggle;
return [_c('v-btn',{key:("menu_group_" + index),staticClass:"mb-2 slider-btn",attrs:{"input-value":active,"ripple":false,"depressed":"","rounded":"","color":menu.primaryColor ? menu.primaryColor : '#000000'},on:{"click":function($event){_vm.onMenuGroupTab(menu.id);
              toggle;
              _vm.selectColor(menu);}}},[_vm._v("\n            "+_vm._s(_vm.translate("name", menu))+"\n          ")])]}}],null,true)}):_vm._e()]})],2)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }